export default "__VITE_ASSET__C$_Gktv5__"